<template>
<div class="chapter">
<div class="inner_page">
<h4 class="h4-a">C<span class="smallcaps">ONTENTS</span></h4>
<p class="normala"><a href="#/05_9781614230007_Foreword">Foreword, by Susan Greene</a></p>
<p class="normala"><a href="#/06_9781614230007_Acknowledgements">Acknowledgements</a></p>
<p class="normal-x"><a href="#/07_9781614230007_Introduction">Introduction. Why Marshall Field’s Matters</a></p>
<p class="normal0"><a href="#/08_9781614230007_CH01">1. From the Farm to the City: Making of a Merchant</a></p>
<p class="normal0"><span href="#/09_9781614230007_CH02" title="Link target outside of Sample">2. Growth and Rebirth: Field, Leiter &amp; Company</span></p>
<p class="normal0"><span href="#/10_9781614230007_CH03" title="Link target outside of Sample">3. Fire and Survival: Aftermath of the Great Chicago Fire</span></p>
<p class="normal0"><span href="#/11_9781614230007_CH04" title="Link target outside of Sample">4. Change and Philanthropy: The Merchant’s Final Years</span></p>
<p class="normal0"><span href="#/12_9781614230007_CH05" title="Link target outside of Sample">5. Continuing the Vision: The John Shedd Years</span></p>
<p class="normal0"><span href="#/13_9781614230007_CH06" title="Link target outside of Sample">6. Progress and Despair: The Great Depression and the World’s Fair</span></p>
<p class="normal0"><span href="#/14_9781614230007_CH07" title="Link target outside of Sample">7. From the City to the Suburbs: The Changing Face of Retail</span></p>
<p class="normal0"><span href="#/15_9781614230007_CH08" title="Link target outside of Sample">8. A Child’s Dream: Christmas at Field’s</span></p>
<p class="normal0"><span href="#/16_9781614230007_CH09" title="Link target outside of Sample">9. Winds of Change: BATUS and Target</span></p>
<p class="normal0"><span href="#/17_9781614230007_CH10" title="Link target outside of Sample">10. An Icon Vanishes: The Coming of Macy’s</span></p>
<p class="normal-1a"><span href="#/18_9781614230007_Epilogue" title="Link target outside of Sample">Epilogue. State Street Today</span></p>
<p class="normala"><span href="#/19_9781614230007_Appendix" title="Link target outside of Sample">Appendix. Marshall Field’s Recipes</span></p>
<p class="normala"><span href="#/20_9781614230007_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="normala"><span href="#/21_9781614230007_Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_9781614230007_Contents.vue?10c18962